import { GetterTree } from 'vuex'
import { RootState } from 'store'
import { TimeSheetTrackingState } from './types'

export const getters: GetterTree<TimeSheetTrackingState, RootState> = {
  timeSheetTrackings: (state: TimeSheetTrackingState) => state.timeSheetTrackings,
  filterTimeSheetTracking: (state: TimeSheetTrackingState) => state.filterTimeSheetTracking,
  timeSheetTrackingCount: (state: TimeSheetTrackingState) => state.timeSheetTrackingCount,
  loading: (state: TimeSheetTrackingState) => state.loading,
}